import Image from "next/image";
import styles from "./SolaIconBadge.module.css";

// The "Bordered Circle" and "Background Circle" treatments from the
// styleguide (/styleguide/iconography), sized relative to the icon (matches
// the xs/s/m/l scale documented there). Defaults to the SOLA mark; pass
// `icon` to badge a different glyph (e.g. the AI magic sparkles icon).
export default function SolaIconBadge({ size = 24, icon = null, variant = "ring" }) {
  const circleSize = Math.round(size * 1.9);
  const glyph = icon || (
    <Image src="/img/floats/sola.svg" alt="" width={size} height={size} />
  );

  if (variant === "background") {
    return (
      <span
        className={styles.background}
        style={{ width: circleSize, height: circleSize }}
      >
        {glyph}
      </span>
    );
  }

  return (
    <span
      className={styles.ring}
      style={{ width: circleSize, height: circleSize }}
    >
      <span className={styles.inner}>{glyph}</span>
    </span>
  );
}
